import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export abstract class BeneficiaryListApiFatoryService {
  abstract getBeneficiaryList(filter: Partial<any>): Observable<any>;
}
